import { getLocale } from "../runtime";

const sv_selectlanguage = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Välj språk / Select language`
};

const selectlanguage = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_selectlanguage(inputs)
	return "selectLanguage";
};

export { selectlanguage as "selectLanguage" };